export default {
  title: 'Hero A'
}

const Template = args => `
  <cradlepoint-hero-a
    title-max-width="${args['title-max-width'] ? args['title-max-width'] : '800px'}"
    text-align="${args['text-align'] ? args['text-align'] : 'left'}"
    background-image="${args['background-image'] && args['background-image']}"
    background-position="${args['background-position'] ? args['background-position'] : 'center'}"
    background-size="${args['background-size'] ? args['background-size'] : 'cover'}"
    padding-top="${args['padding-top'] ? args['padding-top'] : '0'}"
    height="${args['height'] ? args['height'] : '640px'}"
  >
    ${args['text'] && args['text']}
    ${args['content'] && args['content']}
  </cradlepoint-hero-a>
`;

export const Default = Template.bind({});
export const Center = Template.bind({});
export const Right = Template.bind({});
export const WithInnerHTML = Template.bind({});

let argsText =
`<h2 slot="sub-title" class="text-sunrise">Cellular Networking for Construction</h2>
<h1 slot="title" class="text-white">5G for construction efficiency and safety? Built for this.</h1>`;

Default.args = {
  'text': argsText,
  'content': '',
  'title-max-width': '800px',
  'text-align': 'left',
  'background-image': 'https://img.cradlepoint.com/auto-mapping-folder/2023/03/construction-hero-1520x862-1.png',
  'background-position': 'center',
  'background-size': 'cover',
  'padding-top': '0',
  'height': '640px',
}

Center.args = {
  ...Default.args,
  'text-align': 'center',
}

Right.args = {
  ...Default.args,
  'text-align': 'right',
}

WithInnerHTML.args = {
  ...Default.args,
  'text': `<h1 slot="title" class="text-sunrise">W4005 Series 5G Wideband Adapter</h1>`,
  'text-align': 'center',
  'background-image': 'https://img.cradlepoint.com/auto-mapping-folder/2020/03/endpoints-details-hero-bg.jpg',
  'content' : `
  <div slot="content-container" style="margin-top:4rem;">
    <cradlepoint-carousel-container
      max-width="645px"
      height="270px"
      show-dots="true"
      show-arrows="false"
    >
      <div>
        <img src="https://img.cradlepoint.com/auto-mapping-folder/2020/04/w2000-series-front-645x270-1-645x270.png" />
      </div>
      <img src="https://img.cradlepoint.com/auto-mapping-folder/2020/04/w2005-series-back-645x270-1-645x270.png" />
    </cradlepoint-carousel-container>
  </div>
  `
}
